import { useEffect, useState } from "react";
import { LinearProgress } from "@mui/material";
import { Box, Container } from "@mui/system";
import { useNavigate } from "react-router-dom";
import LoginBanner from "../nav/LoginBanner";
import { useNav } from "../../context/NavProvider";
import { useUtils } from "../../context/UtilsProvider";
import { useAuth } from "../../context/AuthProvider";
import { useClient } from "../../context/ClientProvider";
import SnackbarAlert from "../nav/SnackbarAlert";
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import RegOtpRegistrationCard from "../auth/reg-otp/RegOtpRegistrationCard";
import RegOtpLoginCard from "../auth/reg-otp/RegOtpLoginCard";
import ConfirmOtpCard from "../auth/reg-otp/ConfirmOtpCard";
import ForgotPasswordCard from "../auth/reg-otp/ForgotPasswordCard";

import ScriptLoader from "../account/ScriptLoader";

function RegOtpAuthPage() {
  const { useGetConfig } = useClient();
  const { clientConfig } = useGetConfig();
  const [showBanner, setShowBanner] = useState(true);

  const handleBannerClose = () => setShowBanner(false);
  const { setShowFooter } = useNav();
  setShowFooter(false);

  const { setFormState, formState } = useUtils();
  const { useGetAuthUser, authState, authStates } = useAuth();
  const { user, isLoading } = useGetAuthUser();
  const navigate = useNavigate();
  useEffect(() => {
    if (!formState) {
      setFormState({
        accountReference: "",
        dateOfBirth: "",
        postcode: "",
        password: "",
        email: ""
      });
    }
  }, [formState, setFormState]);

  if (isLoading) {
    return <LinearProgress />;
  }

  if (user) {
    navigate("/");
    return null;
  }

  return (
    <>
      <ScriptLoader />
      {formState && (
        <>
            <>
              {clientConfig?.layout?.loginBanner?.enabled && showBanner && (
              <Alert
                variant="filled"
                severity="info"
                onClose={handleBannerClose}
                sx={{ backgroundColor: `${clientConfig?.layout?.loginBanner?.backgroundColour}` }}
              >
                  <AlertTitle>{clientConfig.layout.loginBanner.headerText}</AlertTitle>
                  {clientConfig.layout.loginBanner.paragraphText}
                </Alert>
              )}
            </>
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <LoginBanner />
          </Box>
          <Container sx={{ mt: 4, mb: 7, paddingBottom: "350px" }}>
            <Box
              sx={{
                mt: 0,
              }}
            >
              {authState === authStates.signedOut && <RegOtpLoginCard />}
              {authState === authStates.signUp && <RegOtpRegistrationCard />}
              {authState === authStates.confirmOtp && <ConfirmOtpCard />}
              {authState === authStates.forgotPassword && <ForgotPasswordCard />}
            </Box>
          </Container>
          <SnackbarAlert/>
          {setShowFooter(true)}
        </>
      )}
    </>
  );
}

export default RegOtpAuthPage;
